// import React from "react";

// const PurchaseReportGenerator = () => {
//     const [fromDate, setFromDate] = React.useState('2025-06-26');
//     const [toDate, setToDate] = React.useState('2025-06-26');
//     const [suppliers, setSuppliers] = React.useState([]);
//     const [products, setProducts] = React.useState([]);
  
//     const handlePrint = () => {
//       alert('Generating purchase report...');
//     };
  
//     return (
//       <div style={{ padding: '1rem', maxWidth: '42rem', margin: '0 auto' }}>
//         <h1 style={{ fontSize: '1.5rem', fontWeight: 'bold', marginBottom: '1rem' }}>Purchase Report Generator</h1>
//         <div style={{ marginBottom: '1rem', display: 'flex', alignItems: 'center' }}>
//           <input
//             type="date"
//             style={{ border: '1px solid #ccc', padding: '0.5rem', marginRight: '0.5rem' }}
//             value={fromDate}
//             onChange={(e) => setFromDate(e.target.value)}
//           />
//           <input
//             type="date"
//             style={{ border: '1px solid #ccc', padding: '0.5rem', marginRight: '0.5rem' }}
//             value={toDate}
//             onChange={(e) => setToDate(e.target.value)}
//           />
//         </div>
//         <div style={{ marginBottom: '1rem', display: 'flex', flexWrap: 'wrap', gap: '1rem' }}>
//           <div style={{ width: '30%', padding: '0.5rem', backgroundColor: '#f3f4f6' }}>
//             <h2 style={{ fontWeight: '600' }}>Supplier:</h2>
//             <label style={{ display: 'block' }}>
//               <input type="checkbox" checked={suppliers.includes('all')} onChange={(e) => setSuppliers(e.target.checked ? ['all'] : [])} /> All Suppliers
//             </label>
//             <label style={{ display: 'block' }}>
//               <input type="checkbox" checked={suppliers.includes('agl')} onChange={(e) => setSuppliers(e.target.checked ? ['agl'] : [])} /> AGL
//             </label>
//             <label style={{ display: 'block' }}>
//               <input type="checkbox" checked={suppliers.includes('alagendran car')} onChange={(e) => setSuppliers(e.target.checked ? ['alagendran car'] : [])} /> Alagendran Car
//             </label>
//             <label style={{ display: 'block' }}>
//               <input type="checkbox" checked={suppliers.includes('alpha surgicals')} onChange={(e) => setSuppliers(e.target.checked ? ['alpha surgicals'] : [])} /> Alpha Surgicals
//             </label>
//             <label style={{ display: 'block' }}>
//               <input type="checkbox" checked={suppliers.includes('life care')} onChange={(e) => setSuppliers(e.target.checked ? ['life care'] : [])} /> Life Care
//             </label>
//           </div>
//           <div style={{ width: '30%', padding: '0.5rem', backgroundColor: '#f3f4f6' }}>
//             <h2 style={{ fontWeight: '600' }}>Product:</h2>
//             <label style={{ display: 'block' }}>
//               <input type="checkbox" checked={products.includes('all')} onChange={(e) => setProducts(e.target.checked ? ['all'] : [])} /> All Products
//             </label>
//             <label style={{ display: 'block' }}>
//               <input type="checkbox" checked={products.includes('banana')} onChange={(e) => setProducts(e.target.checked ? ['banana'] : [])} /> Banana
//             </label>
//             <label style={{ display: 'block' }}>
//               <input type="checkbox" checked={products.includes('bt 4 lb')} onChange={(e) => setProducts(e.target.checked ? ['bt 4 lb'] : [])} /> BT 4 LB
//             </label>
//             <label style={{ display: 'block' }}>
//               <input type="checkbox" checked={products.includes('cabinet')} onChange={(e) => setProducts(e.target.checked ? ['cabinet'] : [])} /> Cabinet
//             </label>
//             <label style={{ display: 'block' }}>
//               <input type="checkbox" checked={products.includes('front bumper')} onChange={(e) => setProducts(e.target.checked ? ['front bumper'] : [])} /> Front Bumper
//             </label>
//             <label style={{ display: 'block' }}>
//               <input type="checkbox" checked={products.includes('gas 21 kg')} onChange={(e) => setProducts(e.target.checked ? ['gas 21 kg'] : [])} /> Gas 21 KG
//             </label>
//             <label style={{ display: 'block' }}>
//               <input type="checkbox" checked={products.includes('indian closet')} onChange={(e) => setProducts(e.target.checked ? ['indian closet'] : [])} /> Indian Closet
//             </label>
//           </div>
//         </div>
//         <button
//           style={{ backgroundColor: '#3b82f6', color: 'white', padding: '0.5rem 1rem', borderRadius: '0.25rem' }}
//           onClick={handlePrint}
//         >
//           Print
//         </button>
//       </div>
//     );
//   };
  
//   export default PurchaseReportGenerator;


// import React, { useState, useEffect } from 'react';
// import { database, auth } from './firebase';
// import { ref, onValue, off } from 'firebase/database';
// import { onAuthStateChanged } from 'firebase/auth';
// import ReactDOMServer from 'react-dom/server';
// import * as XLSX from 'xlsx';
// import jsPDF from 'jspdf';
// import 'jspdf-autotable';

// // Helper: Extract city from address
// const getCityFromAddress = (address) => {
//   if (!address) return 'Unknown City';
//   const addressParts = address.trim().split(/\s+/);
//   return addressParts.length > 0 ? addressParts[addressParts.length - 1] : 'Unknown City';
// };

// // Helper: Parse date string to Date object
// const parseInvoiceDate = (dateStr) => {
//   if (!dateStr) return null;
//   // Try multiple date formats
//   const formats = [
//     'DD-MM-YYYY',
//     'YYYY-MM-DD',
//     'MM-DD-YYYY',
//     'YYYY/MM/DD',
//     'DD/MM/YYYY'
//   ];
//   for (const format of formats) {
//     let parsed;
//     if (format === 'DD-MM-YYYY') {
//       const [day, month, year] = dateStr.split('-');
//       parsed = new Date(`${year}-${month}-${day}`);
//     } else if (format === 'YYYY-MM-DD') {
//       parsed = new Date(dateStr);
//     } else if (format === 'MM-DD-YYYY') {
//       const [month, day, year] = dateStr.split('-');
//       parsed = new Date(`${year}-${month}-${day}`);
//     } else if (format === 'YYYY/MM/DD') {
//       parsed = new Date(dateStr.replace(/\//g, '-'));
//     } else if (format === 'DD/MM/YYYY') {
//       const [day, month, year] = dateStr.split('/');
//       parsed = new Date(`${year}-${month}-${day}`);
//     }
//     if (parsed && !isNaN(parsed)) return parsed;
//   }
//   console.warn(`Invalid date format: ${dateStr}`);
//   return null;
// };

// // Helper: Format date to DD-MM-YYYY
// const formatDate = (dateStr) => {
//   const date = parseInvoiceDate(dateStr);
//   if (!date) return dateStr;
//   const day = String(date.getDate()).padStart(2, '0');
//   const month = String(date.getMonth() + 1).padStart(2, '0');
//   const year = date.getFullYear();
//   return `${day}-${month}-${year}`;
// };

// // Filter Section Component
// const FilterSection = ({ title, options, selected, onChange }) => {
//   const handleCheckboxChange = (option) => {
//     if (option === options[0]) { // "All" option
//       if (selected.includes(option)) {
//         onChange([]);
//       } else {
//         onChange([...options]);
//       }
//     } else {
//       const newSelected = selected.includes(option)
//         ? selected.filter(item => item !== option && item !== options[0])
//         : [...selected.filter(item => item !== options[0]), option];
      
//       if (newSelected.length === options.length - 1) {
//         onChange([options[0], ...newSelected]);
//       } else {
//         onChange(newSelected);
//       }
//     }
//   };

//   return (
//     <div style={{
//       backgroundColor: '#f3f4f6',
//       padding: '0.75rem',
//       borderRadius: '6px',
//       boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)'
//     }}>
//       <h2 style={{
//         fontSize: '0.9rem',
//         fontWeight: 600,
//         color: '#1f2937',
//         marginBottom: '0.5rem'
//       }}>{title}</h2>
//       <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
//         {options.map((option) => (
//           <label key={option} style={{
//             display: 'flex',
//             alignItems: 'center',
//             gap: '0.5rem',
//             cursor: 'pointer'
//           }}>
//             <input
//               type="checkbox"
//               checked={selected.includes(option)}
//               onChange={() => handleCheckboxChange(option)}
//               style={{
//                 height: '0.9rem',
//                 width: '0.9rem',
//                 accentColor: '#2563eb',
//                 cursor: 'pointer'
//               }}
//             />
//             <span style={{
//               fontSize: '0.8rem',
//               color: '#374151',
//               userSelect: 'none'
//             }}>{option}</span>
//           </label>
//         ))}
//       </div>
//     </div>
//   );
// };

// // Purchase Report Display Component
// const PurchaseReportDisplay = ({ filters, branchProfile, purchaseData }) => {
//   const reportTitle = 'Productwise Purchase Report';
//   const city = branchProfile.city || getCityFromAddress(branchProfile.address);

//   return (
//     <div style={{
//       backgroundColor: 'white',
//       padding: '1rem',
//       marginTop: '1rem',
//       border: '2px solid #000',
//       fontFamily: 'Arial, sans-serif',
//       fontSize: '12px',
//       pageBreakInside: 'avoid'
//     }} className="print-only">
//       {/* Header */}
//       <div style={{
//         display: 'flex',
//         justifyContent: 'space-between',
//         alignItems: 'flex-start',
//         marginBottom: '1rem',
//         borderBottom: '1px solid #000',
//         paddingBottom: '0.5rem'
//       }}>
//         <div style={{ flex: 1 }}>
//           <h1 style={{
//             fontSize: '16px',
//             fontWeight: 'bold',
//             margin: '0',
//             marginBottom: '0.5rem'
//           }}>
//             {branchProfile.branchName}
//           </h1>
//           <div style={{
//             fontSize: '12px',
//             lineHeight: '1.4'
//           }}>
//             <div style={{ marginBottom: '0.3rem' }}>
//               <strong>{reportTitle}</strong>
//             </div>
//             <div>
//               <strong>From:</strong> {formatDate(filters.fromDate) || 'N/A'} <strong>To:</strong> {formatDate(filters.toDate) || 'N/A'}
//             </div>
//           </div>
//         </div>
//         <div style={{
//           backgroundColor: '#333',
//           color: 'white',
//           padding: '0.5rem 1rem',
//           borderRadius: '1rem',
//           textAlign: 'center',
//           minWidth: '7rem'
//         }}>
//           <div style={{
//             fontSize: '12px',
//             fontWeight: 'bold'
//           }}>{city}</div>
//           <div style={{
//             fontSize: '10px',
//             marginTop: '0.2rem'
//           }}>Option: Abstract</div>
//         </div>
//       </div>

//       {/* Purchase Data Table */}
//       <table style={{
//         width: '100%',
//         borderCollapse: 'collapse',
//         fontSize: '11px',
//         border: '1px solid #000'
//       }}>
//         <thead>
//           <tr style={{ backgroundColor: '#f0f0f0' }}>
//             <th style={{
//               border: '1px solid #000',
//               padding: '0.5rem',
//               textAlign: 'center',
//               fontWeight: 'bold',
//               width: '8%'
//             }}>S.No</th>
//             <th style={{
//               border: '1px solid #000',
//               padding: '0.5rem',
//               textAlign: 'center',
//               fontWeight: 'bold',
//               width: '30%'
//             }}>ProductName</th>
//             <th style={{
//               border: '1px solid #000',
//               padding: '0.5rem',
//               textAlign: 'center',
//               fontWeight: 'bold',
//               width: '15%'
//             }}>Commodity No</th>
//             <th style={{
//               border: '1px solid #000',
//               padding: '0.5rem',
//               textAlign: 'center',
//               fontWeight: 'bold',
//               width: '47%'
//             }}>Barcode</th>
//           </tr>
//         </thead>
//         <tbody>
//           {purchaseData.length === 0 ? (
//             <tr>
//               <td colSpan={4} style={{
//                 border: '1px solid #000',
//                 padding: '1rem',
//                 textAlign: 'center',
//                 color: '#666',
//                 fontStyle: 'italic'
//               }}>
//                 No purchase data found for the selected criteria
//               </td>
//             </tr>
//           ) : (
//             purchaseData.map((product, index) => (
//               <React.Fragment key={index}>
//                 {/* Product Header Row */}
//                 <tr style={{ backgroundColor: '#f9f9f9' }}>
//                   <td style={{
//                     border: '1px solid #000',
//                     padding: '0.4rem',
//                     textAlign: 'center',
//                     fontWeight: 'bold'
//                   }}>{index + 1}.</td>
//                   <td style={{
//                     border: '1px solid #000',
//                     padding: '0.4rem',
//                     textAlign: 'left',
//                     fontWeight: 'bold'
//                   }}>{product.productName}</td>
//                   <td style={{
//                     border: '1px solid #000',
//                     padding: '0.4rem',
//                     textAlign: 'center'
//                   }}>{product.commodityNo || 'N/A'}</td>
//                   <td style={{
//                     border: '1px solid #000',
//                     padding: '0.4rem',
//                     textAlign: 'right'
//                   }}>{product.barcode || 'N/A'}</td>
//                 </tr>
                
//                 {/* Purchase Details Sub-header */}
//                 <tr style={{ backgroundColor: '#e8e8e8' }}>
//                   <td style={{
//                     border: '1px solid #000',
//                     padding: '0.3rem',
//                     textAlign: 'center',
//                     fontSize: '10px',
//                     fontWeight: 'bold'
//                   }}>Date of Purchase</td>
//                   <td style={{
//                     border: '1px solid #000',
//                     padding: '0.3rem',
//                     textAlign: 'center',
//                     fontSize: '10px',
//                     fontWeight: 'bold'
//                   }}>Supplier Name</td>
//                   <td style={{
//                     border: '1px solid #000',
//                     padding: '0.3rem',
//                     textAlign: 'center',
//                     fontSize: '10px',
//                     fontWeight: 'bold'
//                   }}>Batch</td>
//                   <td style={{
//                     border: '1px solid #000',
//                     padding: '0.3rem',
//                     textAlign: 'center',
//                     fontSize: '10px',
//                     fontWeight: 'bold'
//                   }}>
//                     <table style={{ width: '100%', borderCollapse: 'collapse' }}>
//                       <tr>
//                         <td style={{ textAlign: 'center', padding: '0.1rem', borderRight: '1px solid #000' }}>Unit Price</td>
//                         <td style={{ textAlign: 'center', padding: '0.1rem', borderRight: '1px solid #000' }}>Qty</td>
//                         <td style={{ textAlign: 'center', padding: '0.1rem' }}>Net Price</td>
//                       </tr>
//                     </table>
//                   </td>
//                 </tr>
                
//                 {/* Purchase Details Rows */}
//                 {product.purchases.map((purchase, purchaseIndex) => (
//                   <tr key={purchaseIndex} style={{ backgroundColor: 'white' }}>
//                     <td style={{
//                       border: '1px solid #000',
//                       padding: '0.3rem',
//                       textAlign: 'center',
//                       fontSize: '10px'
//                     }}>{formatDate(purchase.invoiceDate)}</td>
//                     <td style={{
//                       border: '1px solid #000',
//                       padding: '0.3rem',
//                       textAlign: 'left',
//                       fontSize: '10px'
//                     }}>{purchase.supplier}</td>
//                     <td style={{
//                       border: '1px solid #000',
//                       padding: '0.3rem',
//                       textAlign: 'center',
//                       fontSize: '10px'
//                     }}>{purchase.batch || 'N/A'}</td>
//                     <td style={{
//                       border: '1px solid #000',
//                       padding: '0.3rem',
//                       fontSize: '10px'
//                     }}>
//                       <table style={{ width: '100%', borderCollapse: 'collapse' }}>
//                         <tr>
//                           <td style={{ textAlign: 'right', padding: '0.1rem', borderRight: '1px solid #000' }}>
//                             {parseFloat(purchase.pRate || 0).toFixed(2)}
//                           </td>
//                           <td style={{ textAlign: 'right', padding: '0.1rem', borderRight: '1px solid #000' }}>
//                             {parseFloat(purchase.qty || 0).toFixed(0)}
//                           </td>
//                           <td style={{ textAlign: 'right', padding: '0.1rem' }}>
//                             {parseFloat(purchase.netValue || 0).toFixed(2)}
//                           </td>
//                         </tr>
//                       </table>
//                     </td>
//                   </tr>
//                 ))}
//               </React.Fragment>
//             ))
//           )}
//         </tbody>
//       </table>
//     </div>
//   );
// };

// // Main Purchase Report Generator Component
// const PurchaseReportGenerator = () => {
//   const [filters, setFilters] = useState({
//     fromDate: '',
//     toDate: '',
//     suppliers: ['All Suppliers'],
//     products: ['All Products']
//   });
//   const [suppliers, setSuppliers] = useState(['All Suppliers']);
//   const [products, setProducts] = useState(['All Products']);
//   const [currentUser, setCurrentUser] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [showReport, setShowReport] = useState(false);
//   const [branchProfile, setBranchProfile] = useState({
//     branchName: 'SUPREME TRADERS',
//     address: '',
//     phone: '',
//     city: ''
//   });
//   const [purchaseData, setPurchaseData] = useState([]);
//   const [rawInvoiceData, setRawInvoiceData] = useState([]);
//   const [rawProductData, setRawProductData] = useState([]);
//   const [error, setError] = useState('');

//   const encodeEmailForPath = (email) => {
//     return email ? email.replace(/[.#$[\]]/g, '_') : '';
//   };

//   // Firebase Auth and Data Loading
//   useEffect(() => {
//     const unsubscribe = onAuthStateChanged(auth, (user) => {
//       setCurrentUser(user);
//       if (user) {
//         loadFirebaseData(user);
//       } else {
//         setError('No user is logged in.');
//         setLoading(false);
//       }
//     });
//     return () => unsubscribe();
//   }, []);

//   const loadFirebaseData = (user) => {
//     const encodedEmail = encodeEmailForPath(user.email);

//     // Load Branch Profile
//     const branchProfileRef = ref(database, `users/${encodedEmail}/branchProfiles`);
//     onValue(branchProfileRef, (snapshot) => {
//       const data = snapshot.val();
//       if (data) {
//         const profiles = Object.values(data);
//         const latestProfile = profiles[profiles.length - 1];
//         setBranchProfile({
//           branchName: latestProfile.branchName || 'SUPREME TRADERS',
//           address: `${latestProfile.address1 || ''} ${latestProfile.address2 || ''}`.trim(),
//           phone: latestProfile.mobileNo || '',
//           city: latestProfile.city || getCityFromAddress(`${latestProfile.address1 || ''} ${latestProfile.address2 || ''}`)
//         });
//       } else {
//         console.warn('No branch profile found.');
//       }
//     }, (error) => {
//       console.error('Error loading branch profile:', error);
//       setError('Failed to load branch profile.');
//     });

//     // Load Suppliers
//     const suppliersRef = ref(database, `users/${encodedEmail}/suppliers`);
//     onValue(suppliersRef, (snapshot) => {
//       const data = snapshot.val();
//       if (data) {
//         const supplierList = Object.values(data).map(supplier => supplier.supplierName || 'Unknown Supplier');
//         setSuppliers(['All Suppliers', ...new Set(supplierList)]);
//       } else {
//         console.warn('No suppliers found.');
//         setSuppliers(['All Suppliers']);
//       }
//     }, (error) => {
//       console.error('Error loading suppliers:', error);
//       setError('Failed to load suppliers.');
//     });

//     // Load Products
//     const productsRef = ref(database, `users/${encodedEmail}/products`);
//     onValue(productsRef, (snapshot) => {
//       const data = snapshot.val();
//       if (data) {
//         const productList = Object.entries(data).map(([id, product]) => ({
//           id,
//           productName: product.productName || 'Unknown Product',
//           commodityNo: product.commodityNo || product.productCode || '',
//           barcode: product.barcode || product.productId || ''
//         }));
//         setRawProductData(productList);
//         setProducts(['All Products', ...new Set(productList.map(p => p.productName))]);
//       } else {
//         console.warn('No products found.');
//         setProducts(['All Products']);
//       }
//     }, (error) => {
//       console.error('Error loading products:', error);
//       setError('Failed to load products.');
//     });

//     // Load Invoice Data
//     const invoicesRef = ref(database, `users/${encodedEmail}/invoices`);
//     onValue(invoicesRef, (snapshot) => {
//       const data = snapshot.val();
//       if (data) {
//         const invoiceList = Object.entries(data).flatMap(([id, invoice]) => {
//           if (!invoice.items || !Array.isArray(invoice.items)) {
//             console.warn(`Invoice ${id} has no valid items array.`);
//             return [];
//           }
//           return invoice.items.map(item => ({
//             id,
//             invoiceNo: invoice.supplierDetails?.invoiceNo || 'N/A',
//             invoiceDate: invoice.supplierDetails?.invoiceDate || 'N/A',
//             supplier: invoice.supplierDetails?.supplier || 'N/A',
//             item: item.item || 'N/A',
//             qty: parseFloat(item.qty) || 0,
//             pRate: parseFloat(item.pRate) || 0,
//             tax: parseFloat(item.cgst || 0) + parseFloat(item.sgst || 0) + parseFloat(item.cess || 0),
//             netValue: parseFloat(item.netValue) || 0,
//             batch: item.batch || 'N/A'
//           }));
//         });
//         setRawInvoiceData(invoiceList);
//         console.log('Loaded invoices:', invoiceList);
//       } else {
//         console.warn('No invoices found.');
//         setRawInvoiceData([]);
//       }
//     }, (error) => {
//       console.error('Error loading invoices:', error);
//       setError('Failed to load invoices.');
//     });

//     setLoading(false);

//     return () => {
//       off(branchProfileRef);
//       off(suppliersRef);
//       off(productsRef);
//       off(invoicesRef);
//     };
//   };

//   // Filter and Process Purchase Data
//   useEffect(() => {
//     if (!filters.fromDate || !filters.toDate) {
//       setPurchaseData([]);
//       setError('Please select both From Date and To Date.');
//       return;
//     }

//     const fromDate = new Date(filters.fromDate);
//     const toDate = new Date(filters.toDate);

//     if (isNaN(fromDate) || isNaN(toDate)) {
//       setPurchaseData([]);
//       setError('Invalid date format selected.');
//       return;
//     }

//     // Filter invoices by date range, supplier, and product
//     const filteredInvoices = rawInvoiceData.filter(invoice => {
//       const invoiceDate = parseInvoiceDate(invoice.invoiceDate);
//       if (!invoiceDate) {
//         console.warn(`Skipping invoice ${invoice.id} with invalid date: ${invoice.invoiceDate}`);
//         return false;
//       }
//       const isDateInRange = invoiceDate >= fromDate && invoiceDate <= toDate;
//       const isSupplierMatch = filters.suppliers.includes('All Suppliers') || 
//                              filters.suppliers.includes(invoice.supplier);
//       const isProductMatch = filters.products.includes('All Products') || 
//                             filters.products.includes(invoice.item);
//       return isDateInRange && isSupplierMatch && isProductMatch;
//     });

//     console.log('Filtered invoices:', filteredInvoices);

//     // Group by product name
//     const productGroups = {};
//     filteredInvoices.forEach(invoice => {
//       if (!productGroups[invoice.item]) {
//         // Find product details
//         const productDetails = rawProductData.find(p => p.productName === invoice.item) || {};
//         productGroups[invoice.item] = {
//           productName: invoice.item,
//           commodityNo: productDetails.commodityNo || 'N/A',
//           barcode: productDetails.barcode || 'N/A',
//           purchases: []
//         };
//       }
//       productGroups[invoice.item].purchases.push(invoice);
//     });

//     // Convert to array and sort
//     const processedData = Object.values(productGroups).sort((a, b) => a.productName.localeCompare(b.productName));
    
//     setPurchaseData(processedData);
//     if (processedData.length === 0) {
//       setError('No data matches the selected filters. Try adjusting the date range or selecting different suppliers/products.');
//     } else {
//       setError('');
//     }
//   }, [rawInvoiceData, rawProductData, filters.fromDate, filters.toDate, filters.suppliers, filters.products]);

//   const handleFilterChange = (key, value) => {
//     setFilters({ ...filters, [key]: value });
//     setShowReport(false);
//   };

//   const handleGenerateReport = () => {
//     if (!filters.fromDate || !filters.toDate) {
//       setError('Please select both From Date and To Date.');
//       return;
//     }
//     setShowReport(true);
//   };

//   const handleDownloadExcel = () => {
//     if (purchaseData.length === 0) {
//       setError('No data to export. Generate a report first.');
//       return;
//     }
    
//     const sheetData = [];
//     purchaseData.forEach((product, index) => {
//       // Add product header
//       sheetData.push({
//         'S.No': index + 1,
//         'ProductName': product.productName,
//         'Commodity No': product.commodityNo,
//         'Barcode': product.barcode,
//         'Date of Purchase': '',
//         'Supplier Name': '',
//         'Batch': '',
//         'Unit Price': '',
//         'Qty': '',
//         'Net Price': ''
//       });
      
//       // Add purchase details
//       product.purchases.forEach(purchase => {
//         sheetData.push({
//           'S.No': '',
//           'ProductName': '',
//           'Commodity No': '',
//           'Barcode': '',
//           'Date of Purchase': formatDate(purchase.invoiceDate),
//           'Supplier Name': purchase.supplier,
//           'Batch': purchase.batch,
//           'Unit Price': parseFloat(purchase.pRate).toFixed(2),
//           'Qty': parseFloat(purchase.qty).toFixed(0),
//           'Net Price': parseFloat(purchase.netValue).toFixed(2)
//         });
//       });
//     });

//     const workbook = XLSX.utils.book_new();
//     const worksheet = XLSX.utils.json_to_sheet(sheetData);
//     XLSX.utils.book_append_sheet(workbook, worksheet, 'Purchase Report');
//     XLSX.writeFile(workbook, 'ProductwisePurchaseReport.xlsx');
//   };

//   const handleDownloadPDF = () => {
//     if (purchaseData.length === 0) {
//       setError('No data to export. Generate a report first.');
//       return;
//     }
    
//     const doc = new jsPDF();
//     doc.setFont('Arial', 'normal');
//     doc.setFontSize(12);

//     // Header
//     doc.text(branchProfile.branchName, 10, 10);
//     doc.setFontSize(10);
//     doc.text('Productwise Purchase Report', 10, 20);
//     doc.text(`From: ${formatDate(filters.fromDate) || 'N/A'} To: ${formatDate(filters.toDate) || 'N/A'}`, 10, 30);
//     const city = branchProfile.city || getCityFromAddress(branchProfile.address);
//     doc.text(city, 180, 10, { align: 'right' });

//     // Table data
//     const tableData = [];
//     purchaseData.forEach((product, index) => {
//       tableData.push([
//         index + 1,
//         product.productName,
//         product.commodityNo,
//         product.barcode,
//         '', '', '', '', '', ''
//       ]);
      
//       product.purchases.forEach(purchase => {
//         tableData.push([
//           '',
//           '',
//           '',
//           '',
//           formatDate(purchase.invoiceDate),
//           purchase.supplier,
//           purchase.batch,
//           parseFloat(purchase.pRate).toFixed(2),
//           parseFloat(purchase.qty).toFixed(0),
//           parseFloat(purchase.netValue).toFixed(2)
//         ]);
//       });
//     });

//     doc.autoTable({
//       startY: 40,
//       head: [['S.No', 'ProductName', 'Commodity No', 'Barcode', 'Date of Purchase', 'Supplier Name', 'Batch', 'Unit Price', 'Qty', 'Net Price']],
//       body: tableData,
//       theme: 'grid',
//       headStyles: { fillColor: [240, 240, 240], textColor: [0, 0, 0], fontStyle: 'bold' },
//       styles: { fontSize: 8 },
//       columnStyles: {
//         0: { cellWidth: 15 },
//         1: { cellWidth: 35 },
//         2: { cellWidth: 20 },
//         3: { cellWidth: 20 },
//         4: { cellWidth: 25 },
//         5: { cellWidth: 30 },
//         6: { cellWidth: 15 },
//         7: { cellWidth: 20, halign: 'right' },
//         8: { cellWidth: 15, halign: 'right' },
//         9: { cellWidth: 20, halign: 'right' }
//       }
//     });

//     doc.save('ProductwisePurchaseReport.pdf');
//   };

//   const handlePrint = () => {
//     if (purchaseData.length === 0) {
//       setError('No data to print. Generate a report first.');
//       return;
//     }
    
//     const printContent = React.createElement(PurchaseReportDisplay, {
//       filters: filters,
//       branchProfile: branchProfile,
//       purchaseData: purchaseData
//     });

//     const htmlString = ReactDOMServer.renderToString(printContent);

//     const printWindow = window.open('', '', 'width=800,height=600');
//     printWindow.document.write(`
//       <html>
//         <head>
//           <title>Productwise Purchase Report</title>
//           <style>
//             body { margin: 0; padding: 0; font-family: Arial, sans-serif; }
//             @page { size: A4; margin: 10mm; }
//             table { page-break-inside: auto; }
//             tr { page-break-inside: avoid; page-break-after: auto; }
//             .print-only { border: none !important; }
//           </style>
//         </head>
//         <body>
//           <div id="print-content">${htmlString}</div>
//           <script>
//             setTimeout(function() {
//               window.print();
//               window.close();
//             }, 500);
//           </script>
//         </body>
//       </html>
//     `);
//     printWindow.document.close();
//   };

//   if (loading) {
//     return (
//       <div style={{
//         display: 'flex',
//         justifyContent: 'center',
//         alignItems: 'center',
//         height: '200px',
//         fontSize: '1rem',
//         color: '#666'
//       }}>
//         Loading...
//       </div>
//     );
//   }

//   if (!currentUser) {
//     return (
//       <div style={{
//         textAlign: 'center',
//         padding: '2rem',
//         color: '#718096',
//         fontSize: '1rem'
//       }}>
//         <h2>Please login to access the Purchase Report Generator</h2>
//       </div>
//     );
//   }

//   return (
//     <div style={{
//       width: '100%',
//       maxWidth: '42rem',
//       backgroundColor: '#f8fafc',
//       borderRadius: '8px',
//       boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
//       padding: '1.5rem',
//       margin: '0 auto',
//       fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, sans-serif"
//     }}>
//       <style>
//         {`
//           @media print {
//             body * {
//               visibility: hidden;
//             }
//             .print-only, .print-only * {
//               visibility: visible;
//             }
//             .print-only {
//               position: absolute;
//               left: 0;
//               top: 0;
//               width: 100%;
//               margin: 0;
//               padding: 1rem;
//               box-shadow: none;
//               border: none;
//             }
//           }
//         `}
//       </style>
      
//       <h1 style={{
//         fontSize: '1.5rem',
//         fontWeight: 'bold',
//         color: '#2563eb',
//         marginBottom: '1rem',
//         display: 'flex',
//         alignItems: 'center',
//         gap: '0.5rem'
//       }}>
//         <span role="img" aria-label="chart">📊</span> Productwise Purchase Report
//       </h1>

//       {error && (
//         <div style={{
//           backgroundColor: '#fee2e2',
//           color: '#dc2626',
//           padding: '0.75rem',
//           borderRadius: '6px',
//           marginBottom: '1rem',
//           fontSize: '0.9rem'
//         }}>
//           {error}
//         </div>
//       )}
      
//       {/* Filter Inputs */}
//       <div style={{
//         display: 'grid',
//         gridTemplateColumns: 'repeat(auto-fill, minmax(12rem, 1fr))',
//         gap: '1rem',
//         marginBottom: '1.5rem'
//       }}>
//         <div style={{
//           backgroundColor: '#f3f4f6',
//           padding: '0.75rem',
//           borderRadius: '6px',
//           boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)'
//         }}>
//           <h2 style={{
//             fontSize: '0.9rem',
//             fontWeight: 600,
//             color: '#1f2937',
//             marginBottom: '0.5rem'
//           }}>Date Range</h2>
//           <input
//             type="date"
//             value={filters.fromDate}
//             onChange={(e) => handleFilterChange('fromDate', e.target.value)}
//             style={{
//               width: '100%',
//               padding: '0.5rem',
//               border: '1px solid #d1d5db',
//               borderRadius: '6px',
//               fontSize: '0.8rem'
//             }}
//             placeholder="From Date"
//           />
//           <input
//             type="date"
//             value={filters.toDate}
//             onChange={(e) => handleFilterChange('toDate', e.target.value)}
//             style={{
//               width: '100%',
//               padding: '0.5rem',
//               border: '1px solid #d1d5db',
//               borderRadius: '6px',
//               fontSize: '0.8rem',
//               marginTop: '0.5rem'
//             }}
//             placeholder="To Date"
//           />
//         </div>
//         <FilterSection 
//           title="Suppliers" 
//           options={suppliers} 
//           selected={filters.suppliers} 
//           onChange={(value) => handleFilterChange('suppliers', value)}
//         />
//         <FilterSection 
//           title="Products" 
//           options={products} 
//           selected={filters.products} 
//           onChange={(value) => handleFilterChange('products', value)}
//         />
//       </div>

//       {/* Action Buttons */}
//       <div style={{
//         display: 'flex',
//         gap: '0.75rem',
//         marginBottom: '1.5rem'
//       }}>
//         <button
//           onClick={handleGenerateReport}
//           style={{
//             backgroundColor: '#16a34a',
//             color: 'white',
//             padding: '0.5rem 1rem',
//             borderRadius: '6px',
//             border: 'none',
//             cursor: 'pointer',
//             transition: 'all 0.2s ease',
//             fontSize: '0.8rem',
//             fontWeight: 500,
//             display: 'inline-flex',
//             alignItems: 'center',
//             justifyContent: 'center',
//             minWidth: '7rem'
//           }}
//           onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#15803d'}
//           onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#16a34a'}
//         >
//           Generate Report
//         </button>
//         <button
//           onClick={handleDownloadExcel}
//           style={{
//             backgroundColor: '#8b5cf6',
//             color: 'white',
//             padding: '0.5rem 1rem',
//             borderRadius: '6px',
//             border: 'none',
//             cursor: 'pointer',
//             transition: 'all 0.2s ease',
//             fontSize: '0.8rem',
//             fontWeight: 500,
//             display: 'inline-flex',
//             alignItems: 'center',
//             justifyContent: 'center',
//             minWidth: '7rem'
//           }}
//           onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#7c3aed'}
//           onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#8b5cf6'}
//         >
//           Download Excel
//         </button>
//         <button
//           onClick={handleDownloadPDF}
//           style={{
//             backgroundColor: '#8b5cf6',
//             color: 'white',
//             padding: '0.5rem 1rem',
//             borderRadius: '6px',
//             border: 'none',
//             cursor: 'pointer',
//             transition: 'all 0.2s ease',
//             fontSize: '0.8rem',
//             fontWeight: 500,
//             display: 'inline-flex',
//             alignItems: 'center',
//             justifyContent: 'center',
//             minWidth: '7rem'
//           }}
//           onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#7c3aed'}
//           onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#8b5cf6'}
//         >
//           Download PDF
//         </button>
//         <button
//           onClick={handlePrint}
//           style={{
//             backgroundColor: '#3b82f6',
//             color: 'white',
//             padding: '0.5rem 1rem',
//             borderRadius: '6px',
//             border: 'none',
//             cursor: 'pointer',
//             transition: 'all 0.2s ease',
//             fontSize: '0.8rem',
//             fontWeight: 500,
//             display: 'inline-flex',
//             alignItems: 'center',
//             justifyContent: 'center',
//             minWidth: '6rem'
//           }}
//           onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#2563eb'}
//           onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#3b82f6'}
//         >
//           <span role="img" aria-label="print">🖨️</span> Print
//         </button>
//       </div>

//       {/* Purchase Report Display */}
//       {showReport && (
//         <PurchaseReportDisplay 
//           filters={filters}
//           branchProfile={branchProfile}
//           purchaseData={purchaseData}
//         />
//       )}
//     </div>
//   );
// };

// export default PurchaseReportGenerator;
// PurchaseReportGenerator.js
import React, { useState, useEffect } from 'react';
import { database, auth } from '../firebase';
import { ref, onValue, off } from 'firebase/database';
import { onAuthStateChanged } from 'firebase/auth';
import ReactDOMServer from 'react-dom/server';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable'; // Correct import for jspdf-autotable

// Helper: Extract city from address
const getCityFromAddress = (address) => {
  if (!address) return 'Unknown City';
  const addressParts = address.trim().split(/\s+/);
  return addressParts.length > 0 ? addressParts[addressParts.length - 1] : 'Unknown City';
};

// Helper: Parse date string to Date object
const parseInvoiceDate = (dateStr) => {
  if (!dateStr) return null;
  // Try multiple date formats
  const formats = [
    'DD-MM-YYYY',
    'YYYY-MM-DD',
    'MM-DD-YYYY',
    'YYYY/MM/DD',
    'DD/MM/YYYY'
  ];
  for (const format of formats) {
    let parsed;
    if (format === 'DD-MM-YYYY') {
      const [day, month, year] = dateStr.split('-');
      parsed = new Date(`${year}-${month}-${day}`);
    } else if (format === 'YYYY-MM-DD') {
      parsed = new Date(dateStr);
    } else if (format === 'MM-DD-YYYY') {
      const [month, day, year] = dateStr.split('-');
      parsed = new Date(`${year}-${month}-${day}`);
    } else if (format === 'YYYY/MM/DD') {
      parsed = new Date(dateStr.replace(/\//g, '-'));
    } else if (format === 'DD/MM/YYYY') {
      const [day, month, year] = dateStr.split('/');
      parsed = new Date(`${year}-${month}-${day}`);
    }
    if (parsed && !isNaN(parsed)) return parsed;
  }
  console.warn(`Invalid date format: ${dateStr}`);
  return null;
};

// Helper: Format date to dd-mm-yy
const formatDate = (dateStr) => {
  if (!dateStr) return 'N/A';
  
  // If it's already in YYYY-MM-DD format from HTML date input
  if (dateStr.includes('-') && dateStr.length === 10) {
    const [year, month, day] = dateStr.split('-');
    const shortYear = year.slice(-2);
    return `${day}-${month}-${shortYear}`;
  }
  
  // Parse other formats
  const date = parseInvoiceDate(dateStr);
  if (!date || isNaN(date)) return 'N/A';
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = String(date.getFullYear()).slice(-2);
  return `${day}-${month}-${year}`;
};

// Filter Section Component
const FilterSection = ({ title, options, selected, onChange }) => {
  const handleCheckboxChange = (option) => {
    if (option === options[0]) { // "All" option
      if (selected.includes(option)) {
        onChange([]);
      } else {
        onChange([...options]);
      }
    } else {
      const newSelected = selected.includes(option)
        ? selected.filter(item => item !== option && item !== options[0])
        : [...selected.filter(item => item !== options[0]), option];
      
      if (newSelected.length === options.length - 1) {
        onChange([options[0], ...newSelected]);
      } else {
        onChange(newSelected);
      }
    }
  };

  return (
    <div style={{
      backgroundColor: '#f8fafc',
      padding: '16px',
      borderRadius: '8px',
      border: '1px solid #e2e8f0',
      boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
      transition: 'all 0.3s ease',
      maxWidth: '220px',
      marginBottom: '16px',
    }}>
      <h2 style={{
        fontSize: '16px',
        fontWeight: '600',
        color: '#1e293b',
        marginBottom: '8px',
        borderBottom: '2px solid #3b82f6',
        paddingBottom: '6px',
      }}>{title}</h2>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
        {options.map((option) => (
          <label key={option} style={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: '8px',
            cursor: 'pointer',
            padding: '6px',
            borderRadius: '6px',
            transition: 'background-color 0.2s',
            backgroundColor: selected.includes(option) ? '#eff6ff' : 'transparent',
          }}
          onMouseEnter={(e) => {
            if (!selected.includes(option)) {
              e.currentTarget.style.backgroundColor = '#f1f5f9';
            }
          }}
          onMouseLeave={(e) => {
            if (!selected.includes(option)) {
              e.currentTarget.style.backgroundColor = 'transparent';
            }
          }}
          >
            <input
              type="checkbox"
              checked={selected.includes(option)}
              onChange={() => handleCheckboxChange(option)}
              style={{
                height: '14px',
                width: '14px',
                accentColor: '#3b82f6',
                cursor: 'pointer',
              }}
            />
            <span style={{ 
              fontSize: '14px',
              color: '#475569',
              userSelect: 'none',
              fontWeight: selected.includes(option) ? '500' : '400',
            }}>{option}</span>
          </label>
        ))}
      </div>
    </div>
  );
};

// Purchase Report Display Component
const PurchaseReportDisplay = ({ filters, branchProfile, purchaseData }) => {
  const reportTitle = 'Productwise Purchase Report';
  const city = branchProfile.city || getCityFromAddress(branchProfile.address);

  return (
    <div style={{
      backgroundColor: 'white',
      padding: '30px',
      marginTop: '20px',
      border: '2px solid #3b82f6',
      borderRadius: '12px',
      fontFamily: 'Arial, sans-serif',
      fontSize: '12px',
      pageBreakInside: 'avoid',
      boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1)'
    }} className="print-only">
      {/* Header */}
      <div style={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'flex-start', 
        marginBottom: '30px',
        paddingBottom: '20px',
        borderBottom: '2px solid #e2e8f0'
      }}>
        <div style={{ flex: 1 }}>
          <h1 style={{ 
            fontSize: '24px', 
            fontWeight: 'bold', 
            margin: '0', 
            marginBottom: '15px',
            color: '#1e293b',
            textShadow: '1px 1px 2px rgba(0,0,0,0.1)'
          }}>
            {branchProfile.branchName}
          </h1>
          <div style={{ fontSize: '14px', lineHeight: '1.6', color: '#475569' }}>
            <div style={{ marginBottom: '8px', fontSize: '16px', fontWeight: '600', color: '#3b82f6' }}>
              {reportTitle}
            </div>
            <div style={{ marginTop: '10px' }}>
              <strong>From:</strong> {formatDate(filters.fromDate)} <strong>To:</strong> {formatDate(filters.toDate)}
            </div>
            <div>
              <strong>Suppliers:</strong> {filters.suppliers.includes("All Suppliers") ? "All Suppliers" : filters.suppliers.join(", ")}
            </div>
            <div>
              <strong>Products:</strong> {filters.products.includes("All Products") ? "All Products" : filters.products.join(", ")}
            </div>
          </div>
        </div>
        <div style={{
          background: 'linear-gradient(135deg, #3b82f6 0%, #1e40af 100%)',
          color: 'white',
          padding: '15px 25px',
          borderRadius: '15px',
          textAlign: 'center',
          minWidth: '150px',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
        }}>
          <div style={{ fontSize: '16px', fontWeight: 'bold' }}>{city}</div>
          <div style={{ fontSize: '12px', marginTop: '5px', opacity: '0.9' }}>
            Option: Abstract
          </div>
        </div>
      </div>

      {/* Purchase Data Table */}
      <table style={{
        width: '100%',
        borderCollapse: 'collapse',
        fontSize: '11px',
        border: '2px solid #3b82f6',
        borderRadius: '8px',
        overflow: 'hidden',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
      }}>
        <thead>
          <tr style={{ backgroundColor: '#f1f5f9', borderBottom: '2px solid #3b82f6' }}>
            <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px', width: '8%' }}>S.No</th>
            <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px', width: '25%' }}>Product Name</th>
            <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px', width: '20%' }}>Barcode</th>
            <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px', width: '15%' }}>Date of Purchase</th>
            <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px', width: '20%' }}>Supplier Name</th>
            <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px', width: '12%' }}>Unit Price</th>
            <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px', width: '10%' }}>Qty</th>
            <th style={{ border: '1px solid #cbd5e1', padding: '12px', textAlign: 'center', fontWeight: '600', fontSize: '12px', width: '10%' }}>Net Price</th>
          </tr>
        </thead>
        <tbody>
          {purchaseData.length === 0 ? (
            <tr>
              <td colSpan={8} style={{
                border: '1px solid #cbd5e1',
                padding: '30px',
                textAlign: 'center',
                color: '#64748b',
                fontStyle: 'italic',
                fontSize: '14px',
                backgroundColor: '#f8fafc'
              }}>
                No purchase data found for the selected criteria
              </td>
            </tr>
          ) : (
            purchaseData.map((product, index) => (
              <React.Fragment key={index}>
                {/* Product Header Row */}
                <tr style={{ backgroundColor: '#f9f9f9' }}>
                  <td style={{
                    border: '1px solid #cbd5e1',
                    padding: '8px',
                    textAlign: 'center',
                    fontWeight: 'bold',
                    fontSize: '11px'
                  }}>{index + 1}.</td>
                  <td style={{
                    border: '1px solid #cbd5e1',
                    padding: '8px',
                    textAlign: 'left',
                    fontWeight: 'bold',
                    fontSize: '11px'
                  }}>{product.productName}</td>
                  <td style={{
                    border: '1px solid #cbd5e1',
                    padding: '8px',
                    textAlign: 'center',
                    fontSize: '11px'
                  }}>{product.barcode || 'N/A'}</td>
                  <td style={{ border: '1px solid #cbd5e1', padding: '8px' }}></td>
                  <td style={{ border: '1px solid #cbd5e1', padding: '8px' }}></td>
                  <td style={{ border: '1px solid #cbd5e1', padding: '8px' }}></td>
                  <td style={{ border: '1px solid #cbd5e1', padding: '8px' }}></td>
                  <td style={{ border: '1px solid #cbd5e1', padding: '8px' }}></td>
                </tr>
                
                {/* Purchase Details Rows */}
                {product.purchases.map((purchase, purchaseIndex) => (
                  <tr key={purchaseIndex} style={{ backgroundColor: purchaseIndex % 2 === 0 ? '#ffffff' : '#f8fafc' }}>
                    <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'center', fontSize: '10px' }}></td>
                    <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'left', fontSize: '10px' }}></td>
                    <td style={{ border: '1px solid #cbd5e1', padding: '8px', textAlign: 'center', fontSize: '10px' }}></td>
                    <td style={{
                      border: '1px solid #cbd5e1',
                      padding: '8px',
                      textAlign: 'center',
                      fontSize: '10px'
                    }}>{formatDate(purchase.invoiceDate)}</td>
                    <td style={{
                      border: '1px solid #cbd5e1',
                      padding: '8px',
                      textAlign: 'left',
                      fontSize: '10px'
                    }}>{purchase.supplier}</td>
                    <td style={{
                      border: '1px solid #cbd5e1',
                      padding: '8px',
                      textAlign: 'right',
                      fontSize: '10px'
                    }}>{parseFloat(purchase.pRate || 0).toFixed(2)}</td>
                    <td style={{
                      border: '1px solid #cbd5e1',
                      padding: '8px',
                      textAlign: 'right',
                      fontSize: '10px'
                    }}>{parseFloat(purchase.qty || 0).toFixed(0)}</td>
                    <td style={{
                      border: '1px solid #cbd5e1',
                      padding: '8px',
                      textAlign: 'right',
                      fontSize: '10px'
                    }}>{parseFloat(purchase.netValue || 0).toFixed(2)}</td>
                  </tr>
                ))}
              </React.Fragment>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

// Main Purchase Report Generator Component
const PurchaseReportGenerator = () => {
  const [filters, setFilters] = useState({
    fromDate: '',
    toDate: '',
    suppliers: ['All Suppliers'],
    products: ['All Products']
  });
  const [suppliers, setSuppliers] = useState(['All Suppliers']);
  const [products, setProducts] = useState(['All Products']);
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showReport, setShowReport] = useState(false);
  const [branchProfile, setBranchProfile] = useState({
    branchName: 'SUPREME TRADERS',
    address: '',
    phone: '',
    city: ''
  });
  const [purchaseData, setPurchaseData] = useState([]);
  const [rawInvoiceData, setRawInvoiceData] = useState([]);
  const [rawProductData, setRawProductData] = useState([]);
  const [error, setError] = useState('');

  const encodeEmailForPath = (email) => {
    return email ? email.replace(/[.#$[\]]/g, '_') : '';
  };

  // Firebase Auth and Data Loading
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setCurrentUser(user);
      if (user) {
        loadFirebaseData(user);
      } else {
        setError('No user is logged in.');
        setLoading(false);
      }
    });
    return () => unsubscribe();
  }, []);

  const loadFirebaseData = (user) => {
    const encodedEmail = encodeEmailForPath(user.email);

    // Load Branch Profile
    const branchProfileRef = ref(database, `users/${encodedEmail}/branchProfiles`);
    onValue(branchProfileRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const profiles = Object.values(data);
        const latestProfile = profiles[profiles.length - 1];
        setBranchProfile({
          branchName: latestProfile.branchName || 'SUPREME TRADERS',
          address: `${latestProfile.address1 || ''} ${latestProfile.address2 || ''}`.trim(),
          phone: latestProfile.mobileNo || '',
          city: latestProfile.city || getCityFromAddress(`${latestProfile.address1 || ''} ${latestProfile.address2 || ''}`)
        });
      } else {
        console.warn('No branch profile found.');
      }
    }, (error) => {
      console.error('Error loading branch profile:', error);
      setError('Failed to load branch profile.');
    });

    // Load Suppliers
    const suppliersRef = ref(database, `users/${encodedEmail}/suppliers`);
    onValue(suppliersRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const supplierList = Object.values(data).map(supplier => supplier.supplierName || 'Unknown Supplier');
        setSuppliers(['All Suppliers', ...new Set(supplierList)]);
      } else {
        console.warn('No suppliers found.');
        setSuppliers(['All Suppliers']);
      }
    }, (error) => {
      console.error('Error loading suppliers:', error);
      setError('Failed to load suppliers.');
    });

    // Load Products
    const productsRef = ref(database, `users/${encodedEmail}/products`);
    onValue(productsRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const productList = Object.entries(data).map(([id, product]) => ({
          id,
          productName: product.productName || 'Unknown Product',
          barcode: product.barcode || product.productId || ''
        }));
        setRawProductData(productList);
        setProducts(['All Products', ...new Set(productList.map(p => p.productName))]);
      } else {
        console.warn('No products found.');
        setProducts(['All Products']);
      }
    }, (error) => {
      console.error('Error loading products:', error);
      setError('Failed to load products.');
    });

    // Load Invoice Data
    const invoicesRef = ref(database, `users/${encodedEmail}/invoices`);
    onValue(invoicesRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const invoiceList = Object.entries(data).flatMap(([id, invoice]) => {
          if (!invoice.items || !Array.isArray(invoice.items)) {
            console.warn(`Invoice ${id} has no valid items array.`);
            return [];
          }
          return invoice.items.map(item => ({
            id,
            invoiceNo: invoice.supplierDetails?.invoiceNo || 'N/A',
            invoiceDate: invoice.supplierDetails?.invoiceDate || 'N/A',
            supplier: invoice.supplierDetails?.supplier || 'N/A',
            item: item.item || 'N/A',
            qty: parseFloat(item.qty) || 0,
            pRate: parseFloat(item.pRate) || 0,
            tax: parseFloat(item.cgst || 0) + parseFloat(item.sgst || 0) + parseFloat(item.cess || 0),
            netValue: parseFloat(item.netValue) || 0
          }));
        });
        setRawInvoiceData(invoiceList);
      } else {
        console.warn('No invoices found.');
        setRawInvoiceData([]);
      }
    }, (error) => {
      console.error('Error loading invoices:', error);
      setError('Failed to load invoices.');
    });

    setLoading(false);

    return () => {
      off(branchProfileRef);
      off(suppliersRef);
      off(productsRef);
      off(invoicesRef);
    };
  };

  // Filter and Process Purchase Data
  useEffect(() => {
    if (!filters.fromDate || !filters.toDate) {
      setPurchaseData([]);
      setError('Please select both From Date and To Date.');
      return;
    }

    const fromDate = new Date(filters.fromDate);
    const toDate = new Date(filters.toDate);

    if (isNaN(fromDate) || isNaN(toDate)) {
      setPurchaseData([]);
      setError('Invalid date format selected.');
      return;
    }

    // Filter invoices by date range, supplier, and product
    const filteredInvoices = rawInvoiceData.filter(invoice => {
      const invoiceDate = parseInvoiceDate(invoice.invoiceDate);
      if (!invoiceDate) {
        console.warn(`Skipping invoice ${invoice.id} with invalid date: ${invoice.invoiceDate}`);
        return false;
      }
      const isDateInRange = invoiceDate >= fromDate && invoiceDate <= toDate;
      const isSupplierMatch = filters.suppliers.includes('All Suppliers') || 
                             filters.suppliers.includes(invoice.supplier);
      const isProductMatch = filters.products.includes('All Products') || 
                            filters.products.includes(invoice.item);
      return isDateInRange && isSupplierMatch && isProductMatch;
    });

    // Group by product name
    const productGroups = {};
    filteredInvoices.forEach(invoice => {
      if (!productGroups[invoice.item]) {
        // Find product details
        const productDetails = rawProductData.find(p => p.productName === invoice.item) || {};
        productGroups[invoice.item] = {
          productName: invoice.item,
          barcode: productDetails.barcode || 'N/A',
          purchases: []
        };
      }
      productGroups[invoice.item].purchases.push(invoice);
    });

    // Convert to array and sort
    const processedData = Object.values(productGroups).sort((a, b) => a.productName.localeCompare(b.productName));
    
    setPurchaseData(processedData);
    if (processedData.length === 0) {
      setError('No data matches the selected filters. Try adjusting the date range or selecting different suppliers/products.');
    } else {
      setError('');
    }
  }, [rawInvoiceData, rawProductData, filters.fromDate, filters.toDate, filters.suppliers, filters.products]);

  const handleFilterChange = (key, value) => {
    setFilters({ ...filters, [key]: value });
    setShowReport(false);
  };

  const handleGenerateReport = () => {
    if (!filters.fromDate || !filters.toDate) {
      setError('Please select both From Date and To Date.');
      return;
    }
    setShowReport(true);
  };

  const handleDownloadExcel = () => {
    if (purchaseData.length === 0) {
      setError('No data to export. Generate a report first.');
      return;
    }
    
    const sheetData = [];
    purchaseData.forEach((product, index) => {
      // Add product header
      sheetData.push({
        'S.No': index + 1,
        'Product Name': product.productName,
        'Barcode': product.barcode,
        'Date of Purchase': '',
        'Supplier Name': '',
        'Unit Price': '',
        'Qty': '',
        'Net Price': ''
      });
      
      // Add purchase details
      product.purchases.forEach(purchase => {
        sheetData.push({
          'S.No': '',
          'Product Name': '',
          'Barcode': '',
          'Date of Purchase': formatDate(purchase.invoiceDate),
          'Supplier Name': purchase.supplier,
          'Unit Price': parseFloat(purchase.pRate || 0).toFixed(2),
          'Qty': parseFloat(purchase.qty || 0).toFixed(0),
          'Net Price': parseFloat(purchase.netValue || 0).toFixed(2)
        });
      });
    });

    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(sheetData, {
      header: ['S.No', 'Product Name', 'Barcode', 'Date of Purchase', 'Supplier Name', 'Unit Price', 'Qty', 'Net Price']
    });
    
    // Set column widths for better alignment
    worksheet['!cols'] = [
      { wch: 8 },  // S.No
      { wch: 30 }, // Product Name
      { wch: 20 }, // Barcode
      { wch: 15 }, // Date of Purchase
      { wch: 25 }, // Supplier Name
      { wch: 12 }, // Unit Price
      { wch: 10 }, // Qty
      { wch: 12 }  // Net Price
    ];
    
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Purchase Report');
    XLSX.writeFile(workbook, 'ProductwisePurchaseReport.xlsx');
  };

   const handleDownloadPDF = () => {
    if (purchaseData.length === 0) {
      setError('No data to export. Generate a report first.');
      return;
    }
    
    try {
      const doc = new jsPDF({
        orientation: 'portrait',
        unit: 'mm',
        format: 'a4'
      });
      
      doc.setFont('helvetica', 'normal');
      doc.setFontSize(12);

      // Header
      doc.text(branchProfile.branchName, 10, 10);
      doc.setFontSize(10);
      doc.text('Productwise Purchase Report', 10, 20);
      doc.text(`From: ${formatDate(filters.fromDate)} To: ${formatDate(filters.toDate)}`, 10, 30);
      doc.text(`Suppliers: ${filters.suppliers.includes("All Suppliers") ? "All Suppliers" : filters.suppliers.join(", ")}`, 10, 40);
      doc.text(`Products: ${filters.products.includes("All Products") ? "All Products" : filters.products.join(", ")}`, 10, 50);
      const city = branchProfile.city || getCityFromAddress(branchProfile.address);
      doc.text(city, 190, 10, { align: 'right' });

      // Table data
      const tableData = [];
      purchaseData.forEach((product, index) => {
        tableData.push([
          index + 1,
          product.productName,
          product.barcode,
          '', '', '', '', ''
        ]);
        
        product.purchases.forEach(purchase => {
          tableData.push([
            '',
            '',
            '',
            formatDate(purchase.invoiceDate),
            purchase.supplier,
            parseFloat(purchase.pRate || 0).toFixed(2),
            parseFloat(purchase.qty || 0).toFixed(0),
            parseFloat(purchase.netValue || 0).toFixed(2)
          ]);
        });
      });

      // Use autoTable function
      autoTable(doc, {
        startY: 60,
        head: [['S.No', 'Product Name', 'Barcode', 'Date of Purchase', 'Supplier Name', 'Unit Price', 'Qty', 'Net Price']],
        body: tableData,
        theme: 'grid',
        headStyles: { 
          fillColor: [59, 130, 246], 
          textColor: [255, 255, 255], 
          fontStyle: 'bold',
          fontSize: 10
        },
        styles: { 
          fontSize: 8,
          cellPadding: 2,
          overflow: 'linebreak'
        },
        columnStyles: {
          0: { cellWidth: 10, halign: 'center' },
          1: { cellWidth: 40, halign: 'left' },
          2: { cellWidth: 30, halign: 'center' },
          3: { cellWidth: 20, halign: 'center' },
          4: { cellWidth: 35, halign: 'left' },
          5: { cellWidth: 15, halign: 'right' },
          6: { cellWidth: 10, halign: 'right' },
          7: { cellWidth: 15, halign: 'right' }
        },
        margin: { top: 60, left: 10, right: 10 },
        pageBreak: 'auto',
        didParseCell: (data) => {
          if (data.row.section === 'body' && data.column.index === 0 && data.cell.text[0] !== '') {
            data.cell.styles.fontStyle = 'bold';
          }
        }
      });

      doc.save('ProductwisePurchaseReport.pdf');
    } catch (error) {
      console.error('Error creating PDF:', error);
      setError('Failed to download PDF. Please try again.');
    }
  };

  const handlePrint = () => {
    if (purchaseData.length === 0) {
      setError('No data to print. Generate a report first.');
      return;
    }
    
    const printContent = React.createElement(PurchaseReportDisplay, {
      filters: filters,
      branchProfile: branchProfile,
      purchaseData: purchaseData
    });

    const htmlString = ReactDOMServer.renderToString(printContent);

    const printWindow = window.open('', '', 'width=800,height=600');
    printWindow.document.write(`
      <html>
        <head>
          <title>Productwise Purchase Report</title>
          <style>
            body { margin: 0; padding: 0; font-family: Arial, sans-serif; }
            @page { size: A4; margin: 5mm; }
            table { page-break-inside: auto; }
            tr { page-break-inside: avoid; page-break-after: auto; }
            .print-only { border: none !important; }
          </style>
        </head>
        <body>
          <div id="print-content" class="print-only">${htmlString}</div>
          <script>
            setTimeout(function() {
              window.print();
              window.close();
            }, 500);
          </script>
        </body>
      </html>
    `);
    printWindow.document.close();
  };

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '400px',
        fontSize: '18px',
        color: '#64748b',
        backgroundColor: '#f8fafc',
        borderRadius: '12px',
        border: '1px solid #e2e8f0'
      }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ 
            width: '40px', 
            height: '40px', 
            border: '4px solid #e2e8f0',
            borderTop: '4px solid #3b82f6',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite',
            margin: '0 auto 16px'
          }}></div>
          <div>Loading Purchase Data...</div>
        </div>
      </div>
    );
  }

  if (!currentUser) {
    return (
      <div style={{ 
        textAlign: 'center', 
        padding: '3rem', 
        color: '#64748b', 
        fontSize: '18px',
        backgroundColor: '#f8fafc',
        borderRadius: '12px',
        border: '1px solid #e2e8f0'
      }}>
        <h2 style={{ color: '#1e293b', marginBottom: '16px' }}>Authentication Required</h2>
        <p>Please login to access the Purchase Report Generator</p>
      </div>
    );
  }

  return (
    <div style={{
      width: '100%',
      maxWidth: '90rem',
      backgroundColor: 'white',
      borderRadius: '16px',
      boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
      padding: '32px',
      margin: '0 auto',
      fontFamily: 'system-ui, -apple-system, sans-serif',
      border: '1px solid #e2e8f0'
    }}>
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
          @media print {
            body * { visibility: hidden; }
            .print-only, .print-only * { visibility: visible; }
            .print-only { 
              position: absolute; 
              left: 0; 
              top: 0; 
              width: 100%; 
              margin: 0; 
              padding: 20px; 
              box-shadow: none; 
              border: none;
            }
          }
        `}
      </style>
      
      <div style={{ 
        display: 'flex', 
        alignItems: 'center', 
        gap: '12px',
        marginBottom: '24px',
        paddingBottom: '16px',
        borderBottom: '2px solid #e2e8f0'
      }}>
        <div style={{
          width: '6px',
          height: '32px',
          backgroundColor: '#3b82f6',
          borderRadius: '3px'
        }}></div>
        <h1 style={{
          fontSize: '28px',
          fontWeight: '700',
          color: '#1e293b',
          margin: '0'
        }}>Best Rate Finder</h1>
      </div>

      {error && (
        <div style={{
          backgroundColor: '#fee2e2',
          color: '#dc2626',
          padding: '12px',
          borderRadius: '8px',
          marginBottom: '24px',
          fontSize: '14px',
          border: '1px solid #f87171',
          boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)'
        }}>
          {error}
        </div>
      )}
      
      {/* Filter Inputs */}
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '20px',
        marginBottom: '32px',
        padding: '24px',
        backgroundColor: '#f8fafc',
        borderRadius: '12px',
        border: '1px solid #e2e8f0'
      }}>
        {/* Date Range Section */}
        <div style={{
          backgroundColor: '#f8fafc',
          padding: '16px',
          borderRadius: '8px',
          border: '1px solid #e2e8f0',
          boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
          transition: 'all 0.3s ease'
        }}>
          <h2 style={{
            fontSize: '16px',
            fontWeight: '600',
            color: '#1e293b',
            marginBottom: '8px',
            borderBottom: '2px solid #3b82f6',
            paddingBottom: '6px'
          }}>Date Range</h2>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '8px' }}>
            <input
              type="date"
              value={filters.fromDate}
              onChange={(e) => handleFilterChange('fromDate', e.target.value)}
              style={{
                width: '100%',
                padding: '12px 16px',
                border: '1px solid #d1d5db',
                borderRadius: '8px',
                fontSize: '14px',
                outline: 'none',
                transition: 'all 0.2s',
                backgroundColor: 'white',
                cursor: 'pointer',
                boxSizing: 'border-box'
              }}
              onFocus={(e) => e.target.style.borderColor = '#3b82f6'}
              onBlur={(e) => e.target.style.borderColor = '#d1d5db'}
              placeholder="From Date"
            />
            <input
              type="date"
              value={filters.toDate}
              onChange={(e) => handleFilterChange('toDate', e.target.value)}
              style={{
                width: '100%',
                padding: '12px 16px',
                border: '1px solid #d1d5db',
                borderRadius: '8px',
                fontSize: '14px',
                outline: 'none',
                transition: 'all 0.2s',
                backgroundColor: 'white',
                cursor: 'pointer',
                boxSizing: 'border-box'
              }}
              onFocus={(e) => e.target.style.borderColor = '#3b82f6'}
              onBlur={(e) => e.target.style.borderColor = '#d1d5db'}
              placeholder="To Date"
            />
          </div>
        </div>
        {/* Suppliers and Products Section */}
        <div style={{ 
          display: 'grid', 
          gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', 
          gap: '20px' 
        }}>
          <FilterSection 
            title="Suppliers" 
            options={suppliers} 
            selected={filters.suppliers} 
            onChange={(value) => handleFilterChange('suppliers', value)}
          />
          <FilterSection 
            title="Products" 
            options={products} 
            selected={filters.products} 
            onChange={(value) => handleFilterChange('products', value)}
          />
        </div>
      </div>

      {/* Action Buttons */}
      <div style={{ 
        display: 'flex', 
        gap: '16px', 
        marginBottom: '32px',
        justifyContent: 'center'
      }}>
        <button
          onClick={handleGenerateReport}
          style={{
            background: 'linear-gradient(135deg, #16a34a 0%, #15803d 100%)',
            color: 'white',
            padding: '12px 24px',
            borderRadius: '8px',
            border: 'none',
            cursor: 'pointer',
            transition: 'all 0.3s',
            fontSize: '16px',
            fontWeight: '600',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            minWidth: '140px',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'translateY(-2px)';
            e.currentTarget.style.boxShadow = '0 6px 12px rgba(0, 0, 0, 0.15)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.1)';
          }}
        >
          Generate Report
        </button>
        <button
          onClick={handleDownloadExcel}
          style={{
            background: 'linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)',
            color: 'white',
            padding: '12px 24px',
            borderRadius: '8px',
            border: 'none',
            cursor: 'pointer',
            transition: 'all 0.3s',
            fontSize: '16px',
            fontWeight: '600',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            minWidth: '140px',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'translateY(-2px)';
            e.currentTarget.style.boxShadow = '0 6px 12px rgba(0, 0, 0, 0.15)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.1)';
          }}
        >
          Download Excel
        </button>
        <button
          onClick={handleDownloadPDF}
          style={{
            background: 'linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)',
            color: 'white',
            padding: '12px 24px',
            borderRadius: '8px',
            border: 'none',
            cursor: 'pointer',
            transition: 'all 0.3s',
            fontSize: '16px',
            fontWeight: '600',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            minWidth: '140px',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'translateY(-2px)';
            e.currentTarget.style.boxShadow = '0 6px 12px rgba(0, 0, 0, 0.15)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.1)';
          }}
        >
          Download PDF
        </button>
        <button
          onClick={handlePrint}
          style={{
            background: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
            color: 'white',
            padding: '12px 24px',
            borderRadius: '8px',
            border: 'none',
            cursor: 'pointer',
            transition: 'all 0.3s',
            fontSize: '16px',
            fontWeight: '600',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            minWidth: '120px',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = 'translateY(-2px)';
            e.currentTarget.style.boxShadow = '0 6px 12px rgba(0, 0, 0, 0.15)';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = '0 4px 6px rgba(0, 0, 0, 0.1)';
          }}
        >
          Print Report
        </button>
      </div>

      {/* Purchase Report Display */}
      {showReport && (
        <PurchaseReportDisplay 
          filters={filters}
          branchProfile={branchProfile}
          purchaseData={purchaseData}
        />
      )}
    </div>
  );
};

export default PurchaseReportGenerator;